<template>
    <b-card :title="$translate('filters')" class="text-center" body-class="p-0" title-tag="h5">

        <b-row class="mb-3">
            <b-col md="4" cols="12" class="dd mt-3 text-start">
                <label for="input-location" class="mb-3"><strong>{{ $translate('warehouse_location') }}</strong></label>
                <b-form-select class="form-control" id="input-location" v-model="historyItemsFilter.location_id"
                    :options="locations" value-field="id" text-field="name" block>
                    <template #first>
                        <b-form-select-option :value="null">
                            {{ $translate('select_all') }}
                        </b-form-select-option>
                    </template>
                    <template>
                        <b-form-select-option :value="officerOption">
                            ({{ $translate('officers') }})
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col md="4" cols="12" class="dd mt-3 text-start">
                <label for="input-type" class="mb-3"><strong>{{ $translate('item_type') }}</strong></label>
                <b-form-select class="form-control" id="input-type" v-model="historyItemsFilter.order_item_type_id"
                    :options="orderTypes" value-field="id" text-field="name" block>
                    <template #first>
                        <b-form-select-option :value="null">
                            {{ $translate('select_all') }}
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col md="4" cols="12" class="dd mt-3 text-start">
                <label for="input-officers" class="mb-3"><strong>{{ $translate('officers') }}</strong></label>
                <b-form-select  class="form-control" id="input-1" :disabled="historyItemsFilter.location_id !== officerOption" v-model="historyItemsFilter.officer_id" :options="officers"
                    value-field="id" text-field="name" block>
                    <template #first>
                        <b-form-select-option :value="null">
                            {{ $translate('select_all') }}
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col md="4" cols="12" class="mt-3">
                <label for="input-created_start" class="mb-3"><strong>{{ $translate('from_date') }}</strong></label>
                <b-form-input type="date" :max="historyItemsFilter.toDate" id="input-created_start"
                    v-model="historyItemsFilter.fromDate"></b-form-input>
            </b-col>
            <b-col md="4" cols="12" class="mt-3">
                <label for="input-created_end" class="mb-3"><strong>{{ $translate('to_date') }}</strong></label>
                <b-form-input type="date" :min="historyItemsFilter.fromDate" id="input-created_end" v-model="historyItemsFilter.toDate"></b-form-input>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'inventoryTransfer-historyItemsQueryfilters',
    mixins: [permissionsMixins],

    props: ['orderTypes','officers','locations','value','officerOption',],
    data() {
        return {}
    },
    computed: {
        historyItemsFilter: {
            // getter
            get() {
                console.log('...........', this.value)
                return this.value
            },
        },
    },
    mounted() { },
    methods: {},
}
</script>
